






































































































































	import _, { assign } from "lodash";
	import { UIModel } from "../UIModel";
	import { FrontendBIM360Issue } from "../model/frontend/FrontendBIM360Issue";
	import { Prop, Component, Vue } from "vue-property-decorator";
	import { BIM360IssueStatus, BIM360Issue } from "../model/BIM360Issue";
	import { ForgeUser } from "@/model/ForgeUser";
	import * as moment from "moment";

	// Imports Child Components
	import NewIssueModal from "./../components/issues/new_issue_modal.vue";
	import BulkEditIssueModal from "./../components/issues/bulk_edit_issue_modal.vue";
	import IssueActivityHistoryModal from "./../components/issues/issue_activity_history_modal.vue";
	import { SortOrder } from '@/util/PaginationParameters';
    import { BIM360IssueAttribute } from '@/model/BIM360IssueAttribute';
	import cookie from 'js-cookie';
	import { FrontendBIM360Project } from '@/model/frontend/FrontendBIM360Project';
	@Component({
		components: {
			NewIssueModal,
			BulkEditIssueModal,
			IssueActivityHistoryModal
		},
	})
	export default class Issues extends Vue {
		// Props
		@Prop({ required: true }) public model!: UIModel;

		// Data
		public selected_issue: FrontendBIM360Issue | null = null;
		public issue_activities_modal_open = false;
		public rows_checked = false;
		public sortBehavior = "Sort All";
		public sortOptions = ['Sort All', 'Sort Page'];
		public sortableAttrs = [
			"locationDescription",
			"type",
			"subType",
			"assignedTo",
			"dueDate",
			"status"
		];
		public sortableCustomAttrs = [
			"subContractor"
		];
		public sortedPage: any[] = [];
		//public checkedRows: FrontendBIM360Issue[] = [];
		public availableStatuses: any[] = [
			"draft",
			"open",
			"closed",
			"work_completed",
			"ready_to_inspect",
			"not_approved",
			"in_dispute",
			"void",
			"answered",
		];
		public pageSizes = [
			10, 15, 25, 50, 100
		];
		public isLoading = false;

		// Getters
		get changesMade(): boolean {
			// let count = 0;
			// for (const issue of this.model.projectIssues.data) {
			// 	if (this.model.projectIssues.originalData[count]) {
			// 		const original = this.model.projectIssues.originalData[count];
			// 		if (original.status != issue.status) {
			// 			return true;
			// 		}
			// 	} else {
			// 		return true;
			// 	}
			// }
			// return false;
			if (this.model.projectIssues.data) {
				for (const issue of this.model.projectIssues.data) {
					if (issue.isUpdated()) return true;
				}
			}
			return false;
		}

		get statusOptions() {
			return [
				{ name: "Show All Status", value: "" },
				{ name: "Draft", value: "draft" },
				{ name: "Open", value: "open" },
				{ name: "Work Completed", value: "work_completed" },
				{ name: "Ready to Inspect", value: "ready_to_inspect" },
				{ name: "In Dispute", value: "in_dispute" },
				{ name: "Not Approved", value: "not_approved" },
				{ name: "Answered", value: "answered" },
				{ name: "Void", value: "void" },
				{ name: "Closed", value: "closed" },
			]
		}

		get issueData(): any[] {
			if (this.sortBehavior == 'Sort All' || this.sortedPage.length == 0) {
				return this.model.projectIssues.data;
			} else {
				return this.sortedPage;
			}
		}

		get canSortPage(): boolean {
			return this.sortBehavior == 'Sort Page';
		}

		public beforeMount(){
			this.model.initIssueModule();
		}

		// Created
		public created(): void {
			if (!this.model.selectedHub && !this.model.selectedProject) {
				//this.$router.push("/");
			}
		}

		// Methods
		public openIssueActivityHistory(issue: FrontendBIM360Issue): void {
			this.selected_issue = issue;
			this.issue_activities_modal_open = true;
		}

		public sortIssues(field: string, order: SortOrder): void {
			if (this.sortBehavior == "Sort All") {
				this.model.projectIssues.setSorting(field, order);
			} else {
				// Copy all issues for modification and lookup
				const issues = JSON.parse(JSON.stringify(this.model.projectIssues.data));

				// Find the friendly values for the field that you're sorting on
				if (this.sortableAttrs.indexOf(field) !== -1 || this.sortableCustomAttrs.indexOf(field) !== -1) {
					let custom_attribute_index = 0;
					for (const issue of issues) {
						if (field.toLowerCase() == 'subcontractor') {
							for (const attribute of issue.customAttributes) {
								if (attribute.title == 'Subcontractor') {
									issue.subcontractor = attribute.value;
									custom_attribute_index = issue.customAttributes.indexOf(attribute);
									break;
								}
							}
						} else if (field.toLowerCase() == 'type') {
							issue.type = this.getIssueTypeName(issue.issueTypeId);
						} else if (field.toLowerCase() == 'subtype') {
							issue.subType = this.getIssueTypeName(issue.issueSubtypeId);
						} else if (field.toLowerCase() == 'assignedto') {
							issue.assignedTo = this.getAssigneeName(issue.assignedTo);
						}
					}

					// Sort on the friendly values
					if (this.sortableAttrs.indexOf(field) !== -1) {
						// Sort on attribute
						issues.sort((a: any, b: any) => {
							if (!a[field]) {
								return 1;
							} else if (!b[field]) {
								return -1;
							} else {
								if (field == 'dueDate') {
									return a[field] < b[field] ? (order == 'asc' ? 1 : -1) : (order == 'asc' ? -1 : 1);
								} else {
									return a[field] > b[field] ? (order == 'asc' ? 1 : -1) : (order == 'asc' ? -1 : 1);
								}								
							}
						});
					} else {
						// Sort on custom attribute
						issues.sort((a: any, b: any) => {
							if (!a.customAttributes[custom_attribute_index] || !a.customAttributes[custom_attribute_index].value) {
								return 1;
							} else if (!b.customAttributes[custom_attribute_index] || !b.customAttributes[custom_attribute_index].value) {
								return -1;
							} else {
								return a.customAttributes[custom_attribute_index].value > b.customAttributes[custom_attribute_index].value ? (order == 'asc' ? 1 : -1) : (order == 'asc' ? -1 : 1);
							}
						});
					}

					// Map the issue against the original to get the original data structure
					const sorted_issues = issues.map((issue: any) => {
						return this.model.projectIssues.find(issue.forgeId);
					});

					// Boom, a custom-sorted array
					this.sortedPage = sorted_issues;
				} else {
					this.model.projectIssues.sortLocal(field, order);
					this.sortedPage = JSON.parse(JSON.stringify(this.model.projectIssues.data));
				}
			}
		}

		public async filterByStatus(value: any) {
			this.model.issueCheckedRows = [];
			console.log("Filter by status");
			// this.sortBehavior = 'Sort Page';
			this.model.refreshIssuesData();
		}

		public runSort(value: any): void {
			this.model.issueCheckedRows = [];
			console.log("runSort: ", value);
			if (value == "Sort Page") {
				console.log("Sort current page");
				// this.sortBehavior = 'Sort Page';
				this.sortedPage = JSON.parse(JSON.stringify(this.model.projectIssues.data));
				this.$forceUpdate();
				this.$nextTick();
			}
		}

		public setAvailableStatuses(checkedList: FrontendBIM360Issue[] | any[], row?: FrontendBIM360Issue | null): any {
			//if (row != undefined) {
				let allStatuses: any[] = [];
				this.availableStatuses = [];

				if (checkedList.length > 1) {
					for (const checkedRow of checkedList) {
						allStatuses.push(checkedRow.permittedStatuses);
					}
					this.availableStatuses = _.intersection(...allStatuses);
				} else if (checkedList.length == 1) {
					this.availableStatuses = checkedList[0].permittedStatuses;
				} else {
					this.availableStatuses = [
						"draft",
						"open",
						"closed",
						"work_completed",
						"ready_to_inspect",
						"not_approved",
						"in_dispute",
						"void",
						"answered",
					];
				}
				//console.log(this.availableStatuses);
			//}
		}

		public checkAll(checkedList: FrontendBIM360Issue[]): void {
			// if (checkedList.length > 0 && !this.rows_checked) {
			// 	// Uses the first row as a guard
			// 	let permitted_statuses = [JSON.parse(JSON.stringify(checkedList[0].permittedStatuses))];
			// 	let permitted_statuses_test = JSON.parse(JSON.stringify(permitted_statuses));
			// 	let checkedListCopy = JSON.parse(JSON.stringify(checkedList));
			// 	let valid_rows: any[] = [];

			// 	// For all remaining rows, filter through all and find any whose permitted statuses intersect with the available statuses
			// 	for (let i = 1; i < checkedListCopy.length; i++) {
			// 		permitted_statuses_test.push(checkedListCopy[i].permittedStatuses);
			// 		let intersection = _.intersection(...permitted_statuses_test);
			// 		if (intersection.length == 0) {
			// 			checkedList.splice(i, 1);
			// 		} else {
			// 			valid_rows.push(checkedListCopy[i]);
			// 			permitted_statuses.push(checkedListCopy[i].permittedStatuses);
			// 		}
			// 		permitted_statuses_test = JSON.parse(JSON.stringify(permitted_statuses));
			// 	}
			// 	console.log(`Found ${valid_rows.length} valid rows`);
			// 	console.log(valid_rows);
			// 	this.checkedRows = valid_rows;
			// } else {
			// 	// Nothing selected
			// 	this.checkedRows = [];
			// }
			// this.rows_checked = !this.rows_checked;
			// this.setAvailableStatuses(checkedList);

			// console.log(checkedList);

			// Set allowed to first row
			// if (checkedList.length > 0) {
			// 	// Iterate through all the remaining rows and only add ones that have some intersection with the available statuses
			// 	const remaining = checkedList.filter((value, index) => { index > 0 });
			// 	this.setAvailableStatuses([checkedList[0]], null);
			// 	for (const row of remaining) {
			// 		let intersection = _.intersection(...[this.availableStatuses, row.permittedStatuses]);
			// 		if (intersection.length == 0) {
			// 			console.log("No intersection found");
			// 			remaining.splice(remaining.indexOf(row), 1);
			// 		} else {
			// 			this.setAvailableStatuses(checkedList, null);
			// 		}
			// 	}
			// 	console.log(remaining);
			// 	remaining.push(checkedList[0]);
			// 	checkedList = remaining;
			// } else {
			// 	this.checkedRows = checkedList;
			// 	this.setAvailableStatuses(this.checkedRows, null);
			// }
			// this.$nextTick();

			// console.log(checkedList);
			// if (checkedList.length > 0) {
			// 	this.checkedRows = [checkedList[0]];
			// } else {
			// 	this.checkedRows = checkedList;
			// }

			// this.checkedRows = [];
		
			this.$nextTick();
		}

		public canCheckRow(row: FrontendBIM360Issue): boolean {
			let intersection = _.intersection(...[
				this.availableStatuses,
				row.permittedStatuses,
			]);
			//console.log("canCheckRow");
			return intersection.length > 0;
		}

		public getFriendlyName(status: BIM360IssueStatus) {
			return BIM360Issue.friendlyNameForStatus(status);
		}

		private async changePage(page: number): Promise<void> {
			await this.model.projectIssues.changePage(page - 1);
			this.sortedPage = JSON.parse(JSON.stringify(this.model.projectIssues.data));
		}

		getIssueTypeName(issueTypeId: string) {
			return this.model.projectNGIssueTypesDict[issueTypeId]?.title;
		}

		getAssigneeName(assigneeId: string) {
            let user;
            let role;
            let company;

            if(this.model?.projectUsers) { user = this.model.projectUsers[assigneeId] };
            if(this.model?.projectRoles) { role = this.model.projectRoles[assigneeId] };
            if(this.model?.companies) { company = this.model.companies[assigneeId] };

            return user?.name || role?.name || company?.name;
        }
        
        getSubContractor(customAttributes: BIM360IssueAttribute[]) {
            let subContractorAttribute = customAttributes.find(c => c.title.toLowerCase() == "subcontractor");
            
            // Look up custom attribute definition
            if(subContractorAttribute){          
              let customAttrDef: any = this.model?.issueAttributeDefinitions?.find(a => a.id == subContractorAttribute?.id);

              // Look up value reference
              let val = customAttrDef?.options?.find(o => o.id == subContractorAttribute?.value);
              
              return val?.value;
            }

            else {
                return undefined;
            }
        }

		async changePageSize(pageSize: number): Promise<void> {
			// Do some stuff
			this.model.issueCheckedRows = [];
			this.model.projectIssues.pagination.pageSize = pageSize;
			cookie.set('page_size', pageSize.toString(), { expires: 14 });
			if (this.model && this.model.selectedProject) {
				await this.model.refreshIssuesData();
				this.sortedPage = JSON.parse(JSON.stringify(this.model.projectIssues.data));
			}
		}

		formatDate(date: string) {
			if (date) {
				return moment.default(date).format("DD/MM/YYYY");
			} else {
				return "-";
			}
		}

		public changeCheckedStatus(status: BIM360IssueStatus) {
			for (const row of this.model.issueCheckedRows) {
				row.status = status;
			}
		}

		public createIssue(): void {
			console.log("Yay.... another issue....");
		}

		public cancel(): void {
			this.model.projectIssues.revertToOriginalData();
			this.model.issueCheckedRows = [];
			this.setAvailableStatuses(this.model.issueCheckedRows);
		}

		public async confirm(): Promise<void> {
			this.isLoading = true;
			if (this.model.projectIssues.data) {
				try {
					let allUpdatedIssues = this.model.projectIssues.data.map(
						(s) => {
							if (s.isUpdated()) return s;
						}
					);
					allUpdatedIssues = allUpdatedIssues.filter((p) => p);
					let allUpdatedIssuePromises = this.model.projectIssues.data.map(
						(s) => {
							if (s.isUpdated()) return s.saveChangesPromise();
						}
					);
					allUpdatedIssuePromises = allUpdatedIssuePromises.filter(
						(p) => p
					);
					let results = await Promise.all(allUpdatedIssuePromises);
					allUpdatedIssues.map((s) => {
						if (s) s.cloneMe();
					});
					this.model.refreshIssuesData();
					this.model.issueCheckedRows = [];
					this.setAvailableStatuses(this.model.issueCheckedRows);
				} catch (err) {
					console.error(err);
				}
			}
			this.isLoading = false;
		}

		public async chooseProject(project: FrontendBIM360Project): Promise<void> {
       		this.model.selectProject(project);
    	}
	}
